import React, { useState, useEffect, useContext } from "react"
import Modal from "react-bootstrap/Modal"
import Button from "react-bootstrap/Button"
import Alert from "react-bootstrap/Alert"
import Dropdown from "react-bootstrap/Dropdown"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faPlus, faTimes } from "@fortawesome/free-solid-svg-icons"
import { serverAPI } from "../../services/api/apiParams"
import { userContext } from "../../App"

function AddRecipe({ show, handleClose, recipe }) {
  const [errorMessage, setErrorMessage] = useState("")
  const [save, setSave] = useState("Save")
  const [categories, setcategories] = useState([])
  const [selectedCategory, setSelectedCategory] = useState()
  const [newCategory, setNewCategory] = useState()
  const [addNewCatInput, setAddNewCatInput] = useState(false)
  const { user, setUser } = useContext(userContext)

  useEffect(() => {
    const fetch = async () => {
      const result = await serverAPI.get("api/categories", {
        headers: {
          Accept: "application/json",
        },
      })
      setcategories(result.data)
    }
    fetch()
  }, [])

  const addCategory = async () => {
    setSave("Save")
    if (user.id === undefined) {
      return setErrorMessage("You are not logged in")
    }
    let category = {
      name: newCategory,
      user_id: user.id,
    }
    try {
      const res = await serverAPI.post("/api/categories", category, {
        headers: { "Content-Type": "application/json" },
      })
      setcategories((oldArray) => [...oldArray, res.data])
      setSelectedCategory(res.data)
    } catch (error) {
      const message = error.response.data.message
      console.log(message)
    }

    //reset <input> newcategory value
    setNewCategory("")
    setAddNewCatInput((prev) => !prev)
  }

  const addToFavorites = async (recipe) => {
    if (user.id === undefined) {
      return setErrorMessage("You are not logged in")
    }
    if (selectedCategory?.id === undefined) {
      return setErrorMessage("Select a category")
    }
    setErrorMessage("")
    let favorite = {
      title: recipe.title,
      api_id: recipe.id,
      image: recipe.image,
      category_id: selectedCategory.id,
      user_id: user.id,
    }
    try {
      await serverAPI.post("/api/recipes", favorite, {
        headers: { "Content-Type": "application/json" },
      })
      setSave("Saved")
    } catch (error) {
      const message = error.response.data.message
      setErrorMessage(message)
      setSave("Saved")
    }
  }
  return (
    <Modal
      show={show}
      onHide={handleClose}
      onExit={() => {
        //rest onexit
        setErrorMessage("")
        setSave("Save")
      }}>
      <Modal.Header closeButton>
        <Modal.Title>Save to favorites</Modal.Title>
      </Modal.Header>
      <div className='imgBox'>
        <img src={recipe.image} alt='recipe' className='img-fluid' />
      </div>
      <Modal.Body>
        {errorMessage.length > 0 ? (
          <Alert className='mt-2 alert text-center popup-alert'>
            {errorMessage ?? errorMessage}
          </Alert>
        ) : (
          ""
        )}
        {recipe.title}
      </Modal.Body>
      <Modal.Body>
        {/* select category */}
        {user.id && (
          <div className='d-flex justify-content-between flex-wrap'>
            <div className='d-flex'>
              <Dropdown>
                <Dropdown.Toggle
                  className='myBtn filterBtn'
                  id='dropdown-basic'
                  variant='success'>
                  {selectedCategory
                    ? selectedCategory.name
                    : "Select a category"}
                </Dropdown.Toggle>

                <Dropdown.Menu>
                  {categories.length > 0 &&
                    categories.map((category) => {
                      return (
                        <Dropdown.Item
                          key={category.id}
                          onClick={() => {
                            setSelectedCategory(category)
                            setSave("Save")
                          }}>
                          {category.name}
                        </Dropdown.Item>
                      )
                    })}
                </Dropdown.Menu>
              </Dropdown>

              <Button
                className='myBtn clear-btn '
                onClick={() => {
                  setSelectedCategory()
                }}>
                <FontAwesomeIcon icon={faTimes} />
              </Button>
            </div>

            <div>
              <Button
                className='myBtn '
                onClick={(e) => {
                  e.currentTarget.blur()
                  addCategory(newCategory)
                }}>
                <FontAwesomeIcon icon={faPlus} />
              </Button>
            </div>
            <input
              placeholder='Add new category'
              className={addNewCatInput ? "catInput" : "catInputhide"}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  addCategory(newCategory)
                }
              }}
              value={newCategory}
              onChange={(e) => {
                setNewCategory(e.target.value)
              }}></input>
          </div>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button
          className='myBtn'
          onClick={() => {
            addToFavorites(recipe)
          }}>
          {save}
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default AddRecipe
